import React, { useEffect, useRef, useState } from "react";
import { useField } from "@unform/core";

import {
  Container,
  LabelRow,
  Label,
  InputWrapper,
  StyledInput,
  ToggleButton,
  ErrorMessage,
} from "./styles";

type NativeInputProps = JSX.IntrinsicElements["input"];

type AuthInputProps = NativeInputProps & {
  name: string;
  label: string;
  /** Conteúdo opcional exibido à direita do label (ex.: "Esqueci minha senha"). */
  labelAction?: React.ReactNode;
  /** Habilita o botão Mostrar/Ocultar para campos de senha. */
  password?: boolean;
};

const AuthInput: React.FC<AuthInputProps> = ({
  name,
  label,
  labelAction,
  password = false,
  type,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [showPassword, setShowPassword] = useState(false);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  const resolvedType = password ? (showPassword ? "text" : "password") : type;

  return (
    <Container>
      <LabelRow>
        <Label htmlFor={name}>{label}</Label>
        {labelAction}
      </LabelRow>
      <InputWrapper>
        <StyledInput
          {...rest}
          id={name}
          ref={inputRef}
          type={resolvedType}
          defaultValue={defaultValue}
          $hasToggle={password}
          $hasError={!!error}
          onChange={(event) => {
            if (error) clearError();
            rest.onChange?.(event);
          }}
        />
        {password && (
          <ToggleButton
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
          >
            {showPassword ? "Ocultar" : "Mostrar"}
          </ToggleButton>
        )}
      </InputWrapper>
      <ErrorMessage>{error}</ErrorMessage>
    </Container>
  );
};

export default AuthInput;
